import { useState, useRef, useEffect } from "react";
import axios from "axios";

import Validation from "../../../Constants/Validation";
import { BASE_NODE_URL, BASE_URL, UPDATE_PERMISSION } from "../../../Constants/Config";
import { useAuthDetails } from "../../../Common/cookiesHelper";
import { ToastifyAlert } from "../../../CommonComponents/ToastifyAlert";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { set } from "date-fns";

const defaultPermissions = {
  cashier: [
    "RG",
    "O",
    "GC",
    "CU",
    "RE",
    "CT",
    "CR",
    "CL",
    "CD",
    "FO",
    "CE",
    "GI",
    "CI",
    "CB",
    "LT",
    "UP",
    "AU",
    "TC",
  ],
  driver: ["TC", "CD"],
  time_clock_only: ["TC"],
};

const EditPermissionLogic = ({ employeedata, setVisible }) => {
  const { isNumber, validateRadioBtn } = Validation();
  const [submitmessage, setsubmitmessage] = useState("");
  const [open, setOpen] = useState(false); // Initialize with false
  const [permissionList, setpermissionList] = useState([]);
  const [tags, setTags] = useState([]);
  const [presetLoading, setPresetLoading] = useState(false);
  // const Navigate = useNavigate();
  const scrollRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const { LoginGetDashBoardRecordJson, LoginAllStore, userTypeData } =
    useAuthDetails();

  let AuthDecryptDataDashBoardJSONFormat = LoginGetDashBoardRecordJson;
  const login_user_email = AuthDecryptDataDashBoardJSONFormat?.data?.email;
  const merchant_id = AuthDecryptDataDashBoardJSONFormat?.data?.merchant_id;

  const employeeListDataState = useSelector((state) => state.employeelistData);

  const [values, setValues] = useState({
    role: "",
    break_allowed: "",
    break_time: "",
    paid_breaks: "",
    permissions: "",
    assigned_stores: "",
    unassigned_stores: "",
    permitted_days: "",
    errors: {
      role: "",
      break_allowed: "",
      break_time: "",
      paid_breaks: "",
      permissions: "",
      permitted_days: "",
    },
  });

  // useEffect(() => {
  //   let arr = employeedata?.permissions?.split(",");
  //   setValues((prevValues) => ({
  //     ...prevValues,
  //     role: employeedata && employeedata.role ? employeedata.role : "manager",
  //     break_allowed:
  //       employeedata && employeedata.break_allowed
  //         ? employeedata.break_allowed
  //         : "",
  //     break_time:
  //       employeedata && employeedata.break_time ? employeedata.break_time : "",
  //     paid_breaks:
  //       employeedata && employeedata.paid_breaks
  //         ? employeedata.paid_breaks
  //         : "",
  //     permissions:
  //       employeedata && employeedata.permissions
  //         ? employeedata.permissions
  //         : ""
  //   }));
  //   const filteredPermissions = Object.values(permissionList)
  //     .map((item) =>
  //       item.filter((i) => arr?.includes(i.id)).map((l) => l.permission_code)
  //     )
  //     .flat()
  //     .toString();

  // }, [employeedata]);

  useEffect(() => {
    let arr = employeedata?.permissions?.split(",");

    if (!employeedata.permissions || employeedata.permissions.trim() === "") {
      const allFields = Object.values(
        employeeListDataState.permissionData || {},
      ).flat();
      const managerPermissions = allFields
        .filter((item) => item.permission_code !== "AAI")
        .map((item) => item.permission_code)
        .join(",");
      setValues((prevValues) => ({
        ...prevValues,
        role: employeedata.role || "manager",
        break_allowed: employeedata?.break_allowed || "",
        break_time: employeedata?.break_time || "",
        paid_breaks: employeedata?.paid_breaks || "",
        permissions: managerPermissions,
        permitted_days: employeedata?.permitted_days || "",
      }));
      return;
    }

    setValues((prevValues) => ({
      ...prevValues,
      role: employeedata?.role || "manager",
      break_allowed: employeedata?.break_allowed || "",
      break_time: employeedata?.break_time || "",
      paid_breaks: employeedata?.paid_breaks || "",
      permissions: employeedata?.permissions || "",
      permitted_days: employeedata?.permitted_days || "",
    }));

    const filteredPermissions = Object.values(permissionList)
      .map((item) =>
        item.filter((i) => arr?.includes(i.id)).map((l) => l.permission_code),
      )
      .flat()
      .toString();
  }, [employeedata, employeeListDataState.permissionData]);

  const handleToggleCategory = (category, checked) => {
    const categoryPermissions = category.map(
      (subItem) => subItem.permission_code,
    );

    setValues((prevValues) => {
      const currentPermissions = prevValues.permissions
        .split(",")
        .filter(Boolean); // Split the current permissions into an array

      if (checked) {
        // If checked, add all category permissions
        return {
          ...prevValues,
          permissions: Array.from(
            new Set([...currentPermissions, ...categoryPermissions]),
          ).toString(), // Remove duplicates and convert back to string
        };
      } else {
        // If unchecked, remove all category permissions
        return {
          ...prevValues,
          permissions: Array.from(
            new Set(
              currentPermissions.filter(
                (id) => !categoryPermissions?.includes(id),
              ),
            ),
          ).toString(), // Remove specified category permissions
        };
      }
    });
  };

  const fetchPresetById = async (id) => {
    setPresetLoading(true);
    try {
      const formData = new FormData();
      formData.append("merchant_id", merchant_id);
      formData.append("preset_id", id);
      formData.append("store_email", login_user_email);

      const response = await axios.post(
        `${BASE_NODE_URL}permission/get_permission_preset_by_id`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${userTypeData?.token}`,
          },
        },
      );

      if (response.data.status && response.data.data?.length > 0) {
        const preset = response.data.data[0]; // ✅ fix here

        // assigned store ids from API (parsed)
        const assignedIds = JSON.parse(preset?.assigned_store);
        console.log("assignedIds", assignedIds);

        // map into AsyncSelect format
        // const formattedAssignedStores = assignedStores.map((store) => ({
        //   value: store.merchant_id,
        //   merchant_id: store.merchant_id,
        //   name: store.name,
        //   label: store.name,
        //   raw: store,
        // }));
        const storeIds = Array.isArray(assignedIds)
          ? assignedIds.map((store) => store.merchant_id)
          : [];
        setTags(assignedIds);

        setValues((prev) => ({
          ...prev,
          role: preset.preset_name || "",
          break_allowed: String(preset.break_allowed ?? ""),
          break_time: String(preset.break_time ?? ""),
          paid_breaks: String(preset.paid_breaks ?? ""),
          permissions: preset.permissions || "",
          assigned_stores: storeIds,
          unassigned_stores: [],
          permitted_days: String(preset.permitted_days ?? "0"),
          errors: {
            role: "",
            break_allowed: "",
            break_time: "",
            paid_breaks: "",
            permissions: "",
            permitted_days: "",
          },
        }));
      } else {
        ToastifyAlert(response.data.msg || "Not Found", "error");
        // navigate("/employee/permission-presets");
      }
    } catch (error) {
      console.error("Error fetching preset by ID:", error);
      ToastifyAlert("Failed to load preset data", error);
    } finally {
      setPresetLoading(false);
    }
  };

  const handleEditEmpPermissionInput = async (event) => {
    let { errors } = values;
    const fieldName = event.target.name; //role
    const fieldValue = event.target.value; //manager

    switch (fieldName) {
      case "break_allowed":
        await isNumber(fieldValue, fieldName, errors);
        break;
      case "break_time":
        await isNumber(fieldValue, fieldName, errors);
        break;
      case "paid_breaks":
        await isNumber(fieldValue, fieldName, errors);
        break;
      case "role":
        const persistId = event.target.dataset.persistid;
        // manager
        // cashier
        // driver
        // time_clock_only

        // console.log(
        //   "employeeListDataState.permissionData: ",
        //   employeeListDataState.permissionData
        // );
        // return;
        fetchPresetById(persistId);
        // on changing of the roles.. set the default permissions based on role to checked..
        if (employeeListDataState.permissionData && fieldValue) {
          //   // value - manager
          //   // const allFields = []; // this will hold all the permission fields

          const allFields = Object.values(
            employeeListDataState.permissionData,
          ).flat();
       
          const selectedPermissions = allFields.filter((item) => {
            // if (fieldValue === "manager") return item; // if manager then allow all items to be checked
            if (fieldValue === "manager") {
              return item.permission_code !== "AAI"; // if manager then allow all items to be checked remove AI
            }

            const permissions = defaultPermissions[fieldValue]; // allowing items based on role
            return permissions?.includes(item.permission_code);
          });

          //   // default permission ids based on the role
          const selectedPermissionsIds = selectedPermissions
            .map((item) => item.permission_code)
            .join(",");
          setValues({
            ...values,
            permissions: selectedPermissionsIds,
          });
        }

        // values.permissions => users default permissions
        await validateRadioBtn(fieldValue, errors);
        break;
      case "permission[]":
        let permissionsArray = values.permissions
          ? values.permissions.split(",")
          : [];
        if (permissionsArray?.includes(event.target.value)) {
          permissionsArray = permissionsArray.filter(
            (item) => item !== event.target.value,
          );
        } else {
          permissionsArray.push(event.target.value);
        }
        const updatedPermissions = permissionsArray.join(",");
        setValues({
          ...values, // Spread the existing state
          permissions: updatedPermissions, // Update only the permissions property
        });
        break;
      case "permitted_days":
        await isNumber(fieldValue, fieldName, errors);
        break;
      default:
        break;
    }

    setValues((prevValues) => ({
      errors,
      ...prevValues,
      [fieldName]: fieldValue,
    }));
  };

  const handleEditEmpPermission = async (e) => {
    e.preventDefault();
    let { errors } = values;
    open && (await isNumber(values.break_allowed, "break_allowed", errors));
    open && (await isNumber(values.break_time, "break_time", errors));
    open && (await isNumber(values.paid_breaks, "paid_breaks", errors));
    await isNumber(values.permitted_days, "permitted_days", errors);
    await validateRadioBtn(values.role, errors);
    const breakAllowed = parseInt(values.break_allowed, 10); // Convert to number explicitly
    const paidBreaks = parseInt(values.paid_breaks, 10);
    // console.log("breakAllowed >= paidBreaks",breakAllowed >= paidBreaks)
    //if (values.break_allowed >= values.paid_breaks) {
    if (open) {
      if (
        values?.break_allowed === "" &&
        values?.break_time === "" &&
        values?.paid_breaks === ""
      ) {
        setValues((prevValues) => ({
          ...prevValues,
          errors: {
            ...prevValues.errors,
            break_allowed: "This field is required",
            break_time: "This field is required",
            paid_breaks: "This field is required",
          },
        }));
        return;
      }
      if (breakAllowed >= paidBreaks) {
        if (
          errors.break_allowed === "" &&
          errors.break_time === "" &&
          errors.paid_breaks === "" &&
          errors.permitted_days === "" &&
          errors.role === ""
        ) {
          const formattedAssignedStores = values?.assigned_stores
            .map((store) => `"${store}"`)
            .join(",");
          const data = {
            merchant_id: merchant_id,
            // "admin_id":"MAL0100CA",
            admin_id: "",
            employee_id: employeedata.id,
            role: values.role,
            break_allowed: !open ? "0" : values.break_allowed,
            break_time: !open ? "0" : values.break_time,
            paid_breaks: !open ? "0" : values.paid_breaks,
            permissions: values.permissions,
            token_id: userTypeData?.token_id,
            login_type: userTypeData?.login_type,
            assigned_stores: formattedAssignedStores,
            unassigned_stores: values?.unassigned_stores,
            permitted_days: !values.permitted_days
              ? "0"
              : values.permitted_days,
          };
          try {
            const response = await axios.post(
              BASE_URL + UPDATE_PERMISSION,
              data,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: `Bearer ${userTypeData?.token}`,
                },
              },
            );

            if (response.data.status === true) {
              // alert(response.data.message)
              setValues({
                role: "",
                break_allowed: "",
                break_time: "",
                paid_breaks: "",
                permissions: "",
                assigned_stores: "",
                unassigned_stores: "",
                permitted_days: "",
                errors: {
                  role: "",
                  break_allowed: "",
                  break_time: "",
                  paid_breaks: "",
                  permissions: "",
                  permitted_days: "",
                },
              });
              ToastifyAlert("Updated Successfully", "success");
              setVisible("EmployeeList");
              Navigate("/store-settings/addemployee");
            } else {
              // alert(response.data.message)
              ToastifyAlert(response?.data?.message, "warn");
              //   await handleScrollClick()
              setsubmitmessage(response.data.message);
              setShowModal(true);
            }
          } catch (error) {
            return new Error(error);
          }
        }

        setValues((prevState) => ({
          ...prevState,
          errors,
        }));
      } else {
        alert(
          "Paid Breaks should be not more than the number of breaks allowed per day",
        );
      }
    } else {
      if (
        errors.break_allowed === "" &&
        errors.break_time === "" &&
        errors.paid_breaks === "" &&
        errors.permitted_days === "" &&
        errors.role === ""
      ) {
        const formattedAssignedStores = values?.assigned_stores
          .map((store) => `"${store}"`)
          .join(",");
        const data = {
          merchant_id: merchant_id,
          // "admin_id":"MAL0100CA",
          admin_id: "",
          employee_id: employeedata.id,
          role: values.role,
          break_allowed: !open ? "0" : values.break_allowed,
          break_time: !open ? "0" : values.break_time,
          paid_breaks: !open ? "0" : values.paid_breaks,
          permissions: values.permissions,
          token_id: userTypeData?.token_id,
          login_type: userTypeData?.login_type,
          assigned_stores: formattedAssignedStores,
          unassigned_stores: values?.unassigned_stores,
          permitted_days: !values.permitted_days ? "0" : values.permitted_days,
        };
        try {
          const response = await axios.post(
            BASE_URL + UPDATE_PERMISSION,
            data,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${userTypeData?.token}`,
              },
            },
          );

          if (response.data.status === true) {
            // alert(response.data.message)
            setValues({
              role: "",
              break_allowed: "",
              break_time: "",
              paid_breaks: "",
              permissions: "",
              assigned_stores: "",
              unassigned_stores: "",
              permitted_days: "",
              errors: {
                role: "",
                break_allowed: "",
                break_time: "",
                paid_breaks: "",
                permissions: "",
                permitted_days: "",
              },
            });
            ToastifyAlert("Updated Successfully", "success");
            setVisible("EmployeeList");
            Navigate("/store-settings/addemployee");
          } else {
            // alert(response.data.message)
            ToastifyAlert(response?.data?.message, "warn");
            //   await handleScrollClick()
            setsubmitmessage(response.data.message);
            setShowModal(true);
          }
        } catch (error) {
          return new Error(error);
        }
      }

      setValues((prevState) => ({
        ...prevState,
        errors,
      }));
    }
  };

  return {
    handleEditEmpPermissionInput,
    handleToggleCategory,
    values,
    handleEditEmpPermission,
    submitmessage,
    setsubmitmessage,
    showModal,
    setShowModal,
    scrollRef,
    open,
    setOpen,
    setValues,
    setpermissionList,
    permissionList,
    tags,
    setTags,
    setPresetLoading,
    presetLoading,
  };
};

export default EditPermissionLogic;
